<template>
  <SignedOut v-if="route.path === '/signed-out' || route.path === '/session-expired'" />
  <App v-else />
</template>

<script setup>
  import { useRoute } from "vue-router";
  import App from "@/views/_app/App.vue";
  import SignedOut from "@/views/SignedOut.vue";
  const route = useRoute();
</script>

<style lang="scss">
  // dependency styles
  @import "primeicons/primeicons.css";
  @import "primeflex/primeflex.css";
  @import "leaflet/dist/leaflet.css";
  @import "leaflet.markercluster/dist/MarkerCluster.css";
  @import "leaflet.markercluster/dist/MarkerCluster.Default.css";
  // our styles
  @import "@/styles/global.scss";
  @import "@/styles/fonts.scss";
  @import "@/styles/icons.scss";
  @import "@/styles/utility.scss";
  @import "@/styles/leaflet.scss";
  @import "@/styles/places.scss";
  @import "@/styles/zendesk.scss";
  @import "@/styles/handyScroll.scss";
</style>